import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { deleteDriverFuelAssignment as deleteDriverFuelAssignmentOperation } from '../operations/deleteDriverFuelAssignment';

import { STATUS_LOADING } from 'common/constants';

export const deleteDriverFuelAssignment = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(deleteDriverFuelAssignmentOperation.pending, (state) => {
    state.fuelAssignment.deletingStatus = STATUS_LOADING.load;
  })
  .addCase(deleteDriverFuelAssignmentOperation.fulfilled, (state) => {
    state.fuelAssignment.deletingStatus = STATUS_LOADING.done;
  })
  .addCase(deleteDriverFuelAssignmentOperation.rejected, (state) => {
    state.fuelAssignment.deletingStatus = STATUS_LOADING.error;
  });